import { useState } from 'react'

import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import { Typography } from '@mui/material'

import {
  ProductDetailsAccordionDetails,
  ProductDetailsAccordionMain,
  ProductDetailsAccordionSummary,
} from '@/components/ProductDetailsAccordion/ProductDetailsAccordion.styled'

import type { FC, ReactNode } from 'react'

interface ProductDetailsAccordionProps {
  title: ReactNode
  children: ReactNode
  elementId: string
  defaultExpanded?: boolean
  className?: string
}

export const ProductDetailsAccordion: FC<ProductDetailsAccordionProps> = ({
  title,
  elementId,
  className,
  defaultExpanded = false,
  children,
}) => {
  const [isOpen, setIsOpen] = useState(defaultExpanded ? true : false)
  const handleChange = () => {
    setIsOpen(!isOpen)
  }

  return (
    <ProductDetailsAccordionMain
      expanded={isOpen}
      disableGutters
      defaultExpanded={defaultExpanded}
      className={className}
      onChange={handleChange}
    >
      <ProductDetailsAccordionSummary
        expandIcon={
          isOpen ? <RemoveIcon color="secondary" fontSize="medium" /> : <AddIcon color="secondary" fontSize="medium" />
        }
        aria-controls={`${elementId}-content`}
        id={`${elementId}-header`}
      >
        <Typography sx={{ textTransform: 'capitalize', marginBlock: 1 }} variant="pageHeading4">
          {title}
        </Typography>
      </ProductDetailsAccordionSummary>
      <ProductDetailsAccordionDetails> {children} </ProductDetailsAccordionDetails>
    </ProductDetailsAccordionMain>
  )
}
